"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.padding = void 0;
var type_guard_1 = require("@webnuts/type-guard");
var measure_unit_1 = require("./measure-unit");
exports.padding = type_guard_1.union([
    type_guard_1.props({
        top: type_guard_1.optional(measure_unit_1.measureUnit),
        right: type_guard_1.optional(measure_unit_1.measureUnit),
        bottom: type_guard_1.optional(measure_unit_1.measureUnit),
        left: type_guard_1.optional(measure_unit_1.measureUnit)
    }),
    measure_unit_1.measureUnit
]);
